import Nav from "../Nav/Nav";
import BestInCategory from "../BestInCategory/BestInCategory";
import PopularCollection from "../PopularCollection/PopularCollection";
// import BestOfBest from '../BestOfBest/BestOfBest';
import Footer from "../Footer/Footer";
import gsap from "gsap";
import { useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// import NewBestOfBest from "../BestOfBest/NewBestOfBest";
import Iphone17 from "../AppleStore/Iphone/Iphone17/Iphone17";
import TopHighlights from "../TopHighlights/TopHighlights";
// import SpecialOffer from "../SpecialOffer/SpecialOffer";
// import S26 from "../SamsungStore/S26";
import InstagramReels from "../InstagramReels/InstagramReels";

function Home() {
  const navigate = useNavigate();

  const mainHeading = useRef(null);
  const mainImage = useRef(null);
  const mainDiscountTitle = useRef(null);

  const timeLine = useRef(null);

  useEffect(() => {
    if (!timeLine.current) {
      timeLine.current = gsap.timeline();

      timeLine.current
        .fromTo(
          mainHeading.current,
          {
            scale: 0.2,
            opacity: 0,
          },
          {
            scale: 1,
            opacity: 1,
            duration: 1,
            delay: 1,
          }
        )
        .fromTo(
          mainImage.current,
          {
            opacity: 0,
            x: 700,
          },
          {
            opacity: 1,
            x: 0,
            duration: 1,
          }
        )
        .fromTo(
          mainDiscountTitle.current,
          {
            opacity: 0,
            x: 700,
          },
          {
            opacity: 1,
            x: 0,
            duration: 1,
          }
        );
    }
  }, []);

  return (
    <div className="home-container">
      <section>
        <Nav theme="light" />
        {/* <SpecialOffer />
        <S26 /> */}
        <div className="header-btn-container">
          <button
            className="header-btn2"
            onClick={() => {
              navigate("/aboutus");
            }}
          >
            About Us
          </button>
          <button
            className="header-btn1"
            onClick={() => {
              navigate("/contactus");
            }}
          >
            Contact Us
          </button>
        </div>
        <div className="main">
          {/* Comment as per Client's request */}
          {/* <div ref={mainHeading} className="header">
            <h1 className="heading">
              Experience the Future with Galaxcity Phones
            </h1>
            <p>Revolutionize Your Mobile Experience with Galaxcity</p>
            <button
              onClick={() => {
                navigate("/contactus");
              }}
            >
              Contact us
            </button>
          </div> */}
          {/* <div className="header-img">
            <div className="header-image">
              <div className="header-text" ref={mainDiscountTitle}>
                <h1>
                  <strong>{headerData.heading}</strong>
                </h1>
              </div>
              <div className="header-image-container">
                <div ref={mainImage}>
                  <img src={headerData.image} alt="header-image" />
                </div>

                <div className="header-text-container" ref={mainHeading}>
                  <p
                    dangerouslySetInnerHTML={{ __html: headerData.subHeading }}
                  />
                  <div className="header-btn">
                    <p
                      dangerouslySetInnerHTML={{
                        __html: headerData.buttonText,
                      }}
                    />

                    <span className="header-btn-subtext">
                      {headerData.buttonSubText}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          <section>
            <Iphone17 />
          </section>
        </div>
      </section>
      <section id="top-highlights">
        <TopHighlights />
      </section>
      <section id="best-in-category">
        <BestInCategory />
      </section>
      <section id="popular-collection">
        <PopularCollection />
      </section>
      {/* <NewBestOfBest /> */}
      <section id="instagram-reels"> 
        <InstagramReels />
      </section>
      <section id="footer">
        <Footer />
      </section>
    </div>
  );
}

export default Home;
